'use client';
import { useState, useEffect } from 'react';
import { getState, subscribe, AppState } from '@/lib/appStore';

/**
 * React hook that returns live app state (user, credits, walletBalance, postCount).
 * Updates automatically when any action mutates the store.
 * Safe for SSR — returns defaults until hydrated on the client.
 */
export function useAppStore(): AppState {
  const [state, setState] = useState<AppState>(() => {
    // SSR-safe: return defaults on server, real values on client
    if (typeof window === 'undefined') {
      return { user: null, credits: 12, walletBalance: 3450, postCount: 0 };
    }
    return getState();
  });

  useEffect(() => {
    // Hydrate immediately on mount
    setState(getState());

    // Subscribe to future changes
    const unsub = subscribe(() => setState(getState()));
    return unsub;
  }, []);

  return state;
}
